import { normalize } from 'normalizr';

import api from '../../api';
import { schema } from '../../schema';
import { addEntities, removeEntity } from '../../actions';
import Format from '../../../lib/Format';
import Logger from '../../../lib/Logger';

// ACTION TYPES

export const IMAGE_UPLOAD_URL_REQUEST = 'MEDIA_IMAGE_UPLOAD_URL_REQUEST';
export const IMAGE_UPLOAD_URL_SUCCESS = 'MEDIA_IMAGE_UPLOAD_URL_SUCCESS';
export const IMAGE_UPLOAD_URL_FAILURE = 'MEDIA_IMAGE_UPLOAD_URL_FAILURE';
export const IMAGE_UPLOAD_REQUEST = 'MEDIA_IMAGE_UPLOAD_REQUEST';
export const IMAGE_UPLOAD_SUCCESS = 'MEDIA_IMAGE_UPLOAD_SUCCESS';
export const IMAGE_UPLOAD_FAILURE = 'MEDIA_IMAGE_UPLOAD_FAILURE';
export const CREATE_IMAGE_REQUEST = 'MEDIA_CREATE_IMAGE_REQUEST';
export const CREATE_IMAGE_SUCCESS = 'MEDIA_CREATE_IMAGE_SUCCESS';
export const CREATE_IMAGE_FAILURE = 'MEDIA_CREATE_IMAGE_FAILURE';
export const MEDIA_LIST_REQUEST = 'MEDIA_LIST_REQUEST';
export const MEDIA_LIST_SUCCESS = 'MEDIA_LIST_SUCCESS';
export const MEDIA_LIST_FAILURE = 'MEDIA_LIST_FAILURE';
export const MEDIA_READ_REQUEST = 'MEDIA_READ_REQUEST';
export const MEDIA_READ_SUCCESS = 'MEDIA_READ_SUCCESS';
export const MEDIA_READ_FAILURE = 'MEDIA_READ_FAILURE';
export const MEDIA_UPDATE_REQUEST = 'MEDIA_UPDATE_REQUEST';
export const MEDIA_UPDATE_SUCCESS = 'MEDIA_UPDATE_SUCCESS';
export const MEDIA_UPDATE_FAILURE = 'MEDIA_UPDATE_FAILURE';
export const MEDIA_CREATE_REQUEST = 'MEDIA_CREATE_REQUEST';
export const MEDIA_CREATE_SUCCESS = 'MEDIA_CREATE_SUCCESS';
export const MEDIA_CREATE_FAILURE = 'MEDIA_CREATE_FAILURE';
export const MEDIA_DELETE_REQUEST = 'MEDIA_DELETE_REQUEST';
export const MEDIA_DELETE_SUCCESS = 'MEDIA_DELETE_SUCCESS';
export const MEDIA_DELETE_FAILURE = 'MEDIA_DELETE_FAILURE';
export const MEDIA_CARE_GUIDE_LIST_REQUEST = 'MEDIA_CARE_GUIDE_LIST_REQUEST';
export const MEDIA_CARE_GUIDE_LIST_SUCCESS = 'MEDIA_CARE_GUIDE_LIST_SUCCESS';
export const MEDIA_CARE_GUIDE_LIST_FAILURE = 'MEDIA_CARE_GUIDE_LIST_FAILURE';
export const MEDIA_PARTNERSHIP_LIST_REQUEST = 'MEDIA_PARTNERSHIP_LIST_REQUEST';
export const MEDIA_PARTNERSHIP_LIST_SUCCESS = 'MEDIA_PARTNERSHIP_LIST_SUCCESS';
export const MEDIA_PARTNERSHIP_LIST_FAILURE = 'MEDIA_PARTNERSHIP_LIST_FAILURE';
export const MEDIA_FORM_DESTROY = 'MEDIA_FORM_DESTROY';
export const MEDIA_CSV_DOWNLOAD_REQUEST = 'MEDIA_CSV_DOWNLOAD_REQUEST';
export const MEDIA_CSV_DOWNLOAD_SUCCESS = 'MEDIA_CSV_DOWNLOAD_SUCCESS';
export const MEDIA_CSV_DOWNLOAD_FAILURE = 'MEDIA_CSV_DOWNLOAD_FAILURE';
export const IMAGE_SIGNED_URL_REQUEST = 'MEDIA_IMAGE_SIGNED_URL_REQUEST';
export const IMAGE_SIGNED_URL_SUCCESS = 'MEDIA_IMAGE_SIGNED_URL_SUCCESS';
export const IMAGE_SIGNED_URL_FAILURE = 'MEDIA_IMAGE_SIGNED_URL_FAILURE';
export const SET_ACTIVE_IMAGE = 'MEDIA_SET_ACTIVE_IMAGE';

// ACTION CREATORS

export function setActiveImage(imageUrl, imagePath) {
  Logger.log(
    'debug',
    `[state.media.actions] setActiveImage(${imageUrl}, ${imagePath})`
  );
  return {
    type: SET_ACTIVE_IMAGE,
    imageUrl: imageUrl,
    imagePath: imagePath,
  };
}

export function mediaListRequest(page, limit, order, filter) {
  Logger.log(
    'debug',
    `[media.actions] mediaListRequest(${page}, ${limit}, ${order}, %j)`,
    filter
  );
  return {
    type: MEDIA_LIST_REQUEST,
    page: page,
    limit: limit,
    order: order,
    filter: filter,
  };
}

export function mediaListSuccess(data) {
  Logger.log('debug', `[media.actions] mediaListSuccess(%j)`, data);
  return {
    type: MEDIA_LIST_SUCCESS,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function mediaListFailure(error) {
  Logger.log('debug', `[media.actions] mediaListFailure(%j)`, error);
  return {
    type: MEDIA_LIST_FAILURE,
    error: error,
  };
}

export function mediaReadRequest(id) {
  Logger.log('debug', `[media.actions] mediaReadRequest(${id})`);
  return {
    type: MEDIA_READ_REQUEST,
    id: id,
  };
}

export function mediaReadSuccess(data) {
  Logger.log('debug', `[media.actions] mediaReadSuccess(%j)`, data);
  return {
    type: MEDIA_READ_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function mediaReadFailure(error) {
  Logger.log('debug', `[media.actions] mediaReadFailure(%j)`, error);
  return {
    type: MEDIA_READ_FAILURE,
    error: error,
  };
}

export function mediaUpdateRequest(id, data) {
  Logger.log('debug', `[media.actions] mediaUpdateRequest(${id}, %j)`, data);
  return {
    type: MEDIA_UPDATE_REQUEST,
  };
}

export function mediaUpdateSuccess(data) {
  Logger.log('debug', `[media.actions] mediaUpdateSuccess(%j)`, data);
  return {
    type: MEDIA_UPDATE_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function mediaUpdateFailure(error) {
  Logger.log('debug', `[media.actions] mediaUpdateFailure(%j)`, error);
  return {
    type: MEDIA_UPDATE_FAILURE,
    error: error,
  };
}

export function mediaCreateRequest(data) {
  Logger.log('debug', `[media.actions] mediaCreateRequest(%j)`, data);
  return {
    type: MEDIA_CREATE_REQUEST,
  };
}

export function mediaCreateSuccess(data) {
  Logger.log('debug', `[media.actions] mediaCreateSuccess(%j)`, data);
  return {
    type: MEDIA_CREATE_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function mediaCreateFailure(error) {
  Logger.log('debug', `[media.actions] mediaCreateFailure(%j)`, error);
  return {
    type: MEDIA_CREATE_FAILURE,
    error: error,
  };
}

export function mediaDeleteRequest(id) {
  Logger.log('debug', `[media.actions] mediaDeleteRequest(${id})`);
  return {
    type: MEDIA_DELETE_REQUEST,
    id: id,
  };
}

export function mediaDeleteSuccess(id) {
  Logger.log('debug', `[media.actions] mediaDeleteSuccess(${id})`);
  return {
    type: MEDIA_DELETE_SUCCESS,
    id: id,
  };
}

export function mediaDeleteFailure(error) {
  Logger.log('debug', `[media.actions] mediaDeleteFailure(%j)`, error);
  return {
    type: MEDIA_DELETE_FAILURE,
    error: error,
  };
}

export function mediaCareGuideListRequest(
  careGuideId,
  page,
  limit,
  order,
  filter
) {
  Logger.log(
    'debug',
    `[media.actions] mediaCareGuideListRequest(${careGuideId}, ${page}, ${limit}, ${order}, %j)`,
    filter
  );
  return {
    type: MEDIA_CARE_GUIDE_LIST_REQUEST,
    careGuideId: careGuideId,
    page: page,
    limit: limit,
    order: order,
    filter: filter,
  };
}

export function mediaCareGuideListSuccess(data) {
  Logger.log('debug', `[media.actions] mediaCareGuideListSuccess(%j)`, data);
  return {
    type: MEDIA_CARE_GUIDE_LIST_SUCCESS,
    careGuideId: data.careGuideId,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function mediaCareGuideListFailure(error) {
  Logger.log('debug', `[media.actions] mediaCareGuideListFailure(%j)`, error);
  return {
    type: MEDIA_CARE_GUIDE_LIST_FAILURE,
    error: error,
  };
}

export function mediaPartnershipListRequest(
  partnershipId,
  page,
  limit,
  order,
  filter
) {
  Logger.log(
    'debug',
    `[media.actions] mediaPartnershipListRequest(${partnershipId}, ${page}, ${limit}, ${order}, %j)`,
    filter
  );
  return {
    type: MEDIA_PARTNERSHIP_LIST_REQUEST,
    partnershipId: partnershipId,
    page: page,
    limit: limit,
    order: order,
    filter: filter,
  };
}

export function mediaPartnershipListSuccess(data) {
  Logger.log('debug', `[media.actions] mediaPartnershipListSuccess(%j)`, data);
  return {
    type: MEDIA_PARTNERSHIP_LIST_SUCCESS,
    partnershipId: data.partnershipId,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function mediaPartnershipListFailure(error) {
  Logger.log('debug', `[media.actions] mediaPartnershipListFailure(%j)`, error);
  return {
    type: MEDIA_PARTNERSHIP_LIST_FAILURE,
    error: error,
  };
}

export function mediaFormDestroy(formState = null) {
  Logger.log('debug', `[media.actions] mediaFormDestroy(%j)`, formState);
  return {
    type: MEDIA_FORM_DESTROY,
    form: formState,
  };
}

export function mediaCSVDownloadRequest(order, filter) {
  Logger.log('debug', `[state.media.actions] mediaCSVDownloadRequest()`);
  return {
    type: MEDIA_CSV_DOWNLOAD_REQUEST,
    order: order,
    filter: filter,
  };
}

export function mediaCSVDownloadSuccess() {
  Logger.log('debug', `[state.media.actions] mediaCSVDownloadSuccess()`);
  return {
    type: MEDIA_CSV_DOWNLOAD_SUCCESS,
  };
}

export function mediaCSVDownloadFailure() {
  Logger.log('debug', `[state.media.actions] mediaCSVDownloadFailure()`);
  return {
    type: MEDIA_CSV_DOWNLOAD_FAILURE,
  };
}

export function mediaImageUploadURLRequest(extension, directory) {
  Logger.log(
    'debug',
    `[state.media.actions] mediaImageUploadURLRequest(${extension}, ${directory})`
  );
  return {
    type: IMAGE_UPLOAD_URL_REQUEST,
    extension: extension,
    directory: directory,
  };
}

export function mediaImageUploadURLSuccess(data) {
  Logger.log(
    'debug',
    `[state.media.actions] mediaImageUploadURLSuccess(%j)`,
    data
  );
  return {
    type: IMAGE_UPLOAD_URL_SUCCESS,
    upload_url: data.upload_url,
    file_id: data.file_id,
    receivedAt: Date.now(),
  };
}

export function mediaImageUploadURLFailure(error) {
  Logger.log(
    'debug',
    `[state.media.actions] mediaImageUploadURLFailure(%j)`,
    error
  );
  return {
    type: IMAGE_UPLOAD_URL_FAILURE,
    error: error,
  };
}

export function mediaImageSignedURLRequest(path) {
  Logger.log(
    'debug',
    `[state.media.actions] mediaImageSignedURLRequest(${path})`
  );
  return {
    type: IMAGE_SIGNED_URL_REQUEST,
    path: path,
  };
}

export function mediaImageSignedURLSuccess(data) {
  Logger.log(
    'debug',
    `[state.media.actions] mediaImageSignedURLSuccess(%j)`,
    data
  );
  return {
    type: IMAGE_SIGNED_URL_SUCCESS,
    signed_url: data.signed_url,
    receivedAt: Date.now(),
  };
}

export function mediaImageSignedURLFailure(error) {
  Logger.log(
    'debug',
    `[state.media.actions] mediaImageSignedURLFailure(%j)`,
    error
  );
  return {
    type: IMAGE_SIGNED_URL_FAILURE,
    error: error,
  };
}

export function mediaImageUploadRequest() {
  Logger.log('debug', `[state.media.actions] mediaImageUploadRequest()`);
  return {
    type: IMAGE_UPLOAD_REQUEST,
  };
}

export function mediaImageUploadSuccess() {
  Logger.log('debug', `[state.media.actions] mediaImageUploadSuccess()`);
  return {
    type: IMAGE_UPLOAD_SUCCESS,
  };
}

export function mediaImageUploadFailure(error) {
  Logger.log(
    'debug',
    `[state.media.actions] mediaImageUploadFailure(%j)`,
    error
  );
  return {
    type: IMAGE_UPLOAD_FAILURE,
    error: error,
  };
}

export function mediaImageCreateRequest(data) {
  Logger.log(
    'debug',
    `[state.media.actions] mediaImageCreateRequest(%j)`,
    data
  );
  return {
    type: CREATE_IMAGE_REQUEST,
  };
}

export function mediaImageCreateSuccess(data) {
  Logger.log(
    'debug',
    `[state.media.actions] mediaImageCreateSuccess(%j)`,
    data
  );
  return {
    type: CREATE_IMAGE_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function mediaImageCreateFailure(error) {
  Logger.log(
    'debug',
    `[state.media.actions] mediaImageCreateFailure(%j)`,
    error
  );
  return {
    type: CREATE_IMAGE_FAILURE,
    error: error,
  };
}

// API THUNK ACTION CREATORS

export function loadMedia(
  page = 1,
  limit = 10,
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[media.actions] loadMedia(${page}, ${limit}, ${order}, %j, ###)`,
    filter
  );

  return async function (dispatch) {
    dispatch(mediaListRequest(page, limit, order, filter));

    // call API
    const response = await api.getMedia(page, limit, order, filter);
    let success = false;

    // get media list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API media list success. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(response.getIn(['data', 'media']), [
        schema.medium,
      ]);
      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(mediaListSuccess(data));
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API media success [empty]. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(mediaListSuccess(data));
      success = true;

      // get media list failure
    } else {
      Logger.log(
        'info',
        `Get API media list failure. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(mediaListFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function loadMedium(id, cb = function () {}) {
  Logger.log('debug', `[media.actions] loadMedium(${id}, ###)`);

  return async function (dispatch) {
    dispatch(mediaReadRequest(id));

    // call API
    const response = await api.getMedium(id);
    let success = false;

    // get medium success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API medium success. ID: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'medium'])],
        [schema.medium]
      );
      const data = {
        id: response.getIn(['data', 'medium', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(mediaReadSuccess(data));
      success = true;

      // get medium failure
    } else {
      Logger.log('info', `Get API medium failure. ID: ${id}.`);
      dispatch(mediaReadFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function updateMedium(id, data, cb = function () {}) {
  Logger.log('debug', `[media.actions] updateMedium(${id}, %j, ###)`, data);

  return async function (dispatch) {
    dispatch(mediaUpdateRequest(id, data));

    // call API
    const response = await api.putMedium(id, data);
    let success = false;

    // put medium success
    if (200 === response.get('status')) {
      Logger.log('info', `PUT API medium success. User: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'medium'])],
        [schema.medium]
      );
      const data = {
        id: response.getIn(['data', 'medium', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(mediaUpdateSuccess(data));
      success = true;

      // get medium failure
    } else {
      Logger.log('info', `PUT API medium failure. ID: ${id}.`);
      dispatch(mediaUpdateFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function createMedia(data, cb = function () {}) {
  Logger.log('debug', `[media.actions] createMedia(%j, ###)`, data);

  return async function (dispatch) {
    dispatch(mediaCreateRequest(data));

    // call API
    const response = await api.postMedia(data);
    let success = false;

    // post media success
    if (201 === response.get('status')) {
      Logger.log(
        'info',
        `POST API media success. Post: ${response.getIn([
          'data',
          'medium',
          'id',
        ])}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'medium'])],
        [schema.medium]
      );
      const data = {
        id: response.getIn(['data', 'medium', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(mediaCreateSuccess(data));
      success = true;

      // get media failure
    } else {
      Logger.log('info', `POST API media failure.`);
      dispatch(mediaCreateFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function deleteMedium(id, cb = function () {}) {
  Logger.log('debug', `[media.actions] deleteMedium(${id}, ###)`);

  return async function (dispatch) {
    dispatch(mediaDeleteRequest(id));

    // call API
    const response = await api.deleteMedium(id);
    let success = false;

    // delete medium success
    if (204 === response.get('status')) {
      Logger.log('info', `DELETE API medium success. ID: ${id}.`);

      dispatch(removeEntity({ entityType: 'media', id: id }));
      dispatch(mediaDeleteSuccess(id));
      success = true;

      // get medium failure
    } else {
      Logger.log('info', `DELETE API medium failure. ID: ${id}.`);
      dispatch(mediaDeleteFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function loadCareGuideMedia(
  careGuideId,
  page = 1,
  limit = 10,
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[media.actions] loadCareGuideMedia(${careGuideId}, ${page}, ${limit}, ${order}, %j, ###)`,
    filter
  );

  return async function (dispatch) {
    dispatch(
      mediaCareGuideListRequest(careGuideId, page, limit, order, filter)
    );

    // call API
    const response = await api.getCareGuideMedia(
      careGuideId,
      page,
      limit,
      order,
      filter
    );
    let success = false;

    // get care guide media list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API care guide media list success. Care Guide: ${careGuideId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(response.getIn(['data', 'media']), [
        schema.medium,
      ]);
      const data = {
        careGuideId: careGuideId,
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(mediaCareGuideListSuccess(data));
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API media success [empty]. Care Guide: ${careGuideId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        careGuideId: careGuideId,
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(mediaCareGuideListSuccess(data));
      success = true;

      // get care guide media list failure
    } else {
      Logger.log(
        'info',
        `Get API care guide media list failure. Care Guide: ${careGuideId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(mediaCareGuideListFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function loadPartnershipMedia(
  partnershipId,
  page = 1,
  limit = 10,
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[media.actions] loadPartnershipMedia(${partnershipId}, ${page}, ${limit}, ${order}, %j, ###)`,
    filter
  );

  return async function (dispatch) {
    dispatch(
      mediaPartnershipListRequest(partnershipId, page, limit, order, filter)
    );

    // call API
    const response = await api.getPartnershipMedia(
      partnershipId,
      page,
      limit,
      order,
      filter
    );
    let success = false;

    // get partnership media list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API partnership media list success. Partnership: ${partnershipId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(response.getIn(['data', 'media']), [
        schema.medium,
      ]);
      const data = {
        partnershipId: partnershipId,
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(mediaPartnershipListSuccess(data));
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API media success [empty]. Partnership: ${partnershipId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        partnershipId: partnershipId,
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(mediaPartnershipListSuccess(data));
      success = true;

      // get partnership media list failure
    } else {
      Logger.log(
        'info',
        `Get API partnership media list failure. Partnership: ${partnershipId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(mediaPartnershipListFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function downloadMediaCSV(
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.media.actions] downloadMediaCSV(${order}, ${filter}, ###)`
  );

  return async function (dispatch) {
    dispatch(mediaCSVDownloadRequest(order, filter));

    // call API
    const response = await api.getMediaCSV(order, filter);

    // get media CSV success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API media CSV success. Order: ${order}`);
      const now = new Date();

      // trigger browser download
      const url = window.URL.createObjectURL(new Blob([response.get('data')]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `cv-media-${Format.date(now, 'YYYY-MM-DDTHHmm')}.csv`
      );
      document.body.appendChild(link);
      link.click();

      dispatch(mediaCSVDownloadSuccess());

      // get media CSV failure
    } else {
      Logger.log('info', `Get API media CSV failure.`);
      dispatch(mediaCSVDownloadFailure());
    }

    // callback function
    cb();
  };
}

export function getImageUploadURL(extension, directory, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.media.actions] getImageUploadURL(${extension}, ${directory})`
  );

  return async function (dispatch) {
    dispatch(mediaImageUploadURLRequest(extension, directory));

    // call API
    const response = await api.getMediaImageUploadURL(extension, directory);
    let success = false;
    const imageUploadUrlSuccessData = {
      upload_url: null,
      file_id: null,
    };

    // get image upload url success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API image upload URL success.`);

      success = true;
      imageUploadUrlSuccessData.upload_url = response.getIn([
        'data',
        'upload_url',
      ]);
      imageUploadUrlSuccessData.file_key = response.getIn(['data', 'file_key']);

      dispatch(mediaImageUploadURLSuccess(imageUploadUrlSuccessData));

      // get image upload url failure
    } else {
      Logger.log('info', `Get API image upload URL failure.`);
      dispatch(mediaImageUploadURLFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(
      success,
      imageUploadUrlSuccessData.upload_url,
      imageUploadUrlSuccessData.file_key
    );
  };
}

export function getImageSignedURL(path, cb = function () {}) {
  Logger.log('debug', `[state.media.actions] getImageSignedURL(${path})`);

  return async function (dispatch) {
    dispatch(mediaImageSignedURLRequest(path));

    // call API
    const response = await api.getMediaImageSignedURL(path);
    let success = false;
    const imageUploadUrlSuccessData = {
      signed_url: null,
    };

    // get image signed url success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API image signed URL success.`);

      success = true;
      imageUploadUrlSuccessData.signed_url = response.getIn([
        'data',
        'signed_url',
      ]);

      dispatch(mediaImageSignedURLSuccess(imageUploadUrlSuccessData));

      // get image signed url failure
    } else {
      Logger.log('info', `Get API image signed URL failure.`);
      dispatch(mediaImageSignedURLFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success, imageUploadUrlSuccessData.signed_url);
  };
}

export function uploadImage(path, file, cb = function () {}) {
  Logger.log('debug', `[state.media.actions] uploadImage(${path}, ###, ###)`);

  return async function (dispatch) {
    dispatch(mediaImageUploadRequest());

    // call API
    const response = await api.putS3Upload(path, file);
    let success = false;

    // put image success
    if (200 === response.get('status')) {
      Logger.log('info', `PUT S3 image success.`);
      success = true;
      dispatch(mediaImageUploadSuccess());

      // put image failure
    } else {
      Logger.log('info', `PUT S3 image failure.`);
      dispatch(mediaImageUploadFailure('Upload error.'));
    }

    // callback function
    cb(success);
  };
}

export function createMediaImage(data, cb = function () {}) {
  Logger.log('debug', `[state.media.actions] createMediaImage(%j, ###)`, data);

  return async function (dispatch) {
    dispatch(mediaImageCreateRequest(data));

    // call API
    const response = await api.postMediaImage(data);
    let success = false;
    let id = null;

    // post media image success
    if (201 === response.get('status')) {
      Logger.log('info', `POST API media image success.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'media'])],
        [schema.medium]
      );

      const data = {
        id: response.getIn(['data', 'media', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(mediaImageCreateSuccess(data));
      success = true;
      id = data.id;

      // post media image failure
    } else {
      Logger.log('info', `POST API media image failure.`);
      dispatch(mediaImageCreateFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success, id);
  };
}

Logger.log('silly', `media.actions loaded.`);
